(function () {
  function init() {
    const header = document.querySelector('.xo-header--style-3');
    if (!header) return;

    const section = header.closest('.section-header');
    const body = header.querySelector('.xo-header__body');
    if (!body) return;

    // Hero-aware logo rule: on pages that lead with a hero (the home page), the
    // logo stays visible while the hero is on screen, then hides. On every other
    // page the logo shows ONLY at the very top and hides the moment you scroll.
    // Mirrors the hero selector used in section-header-style-3.css.
    const heroEl = document.querySelector('#xo-main-content > .shopify-section.section-hero:first-child');
    const heroMode = !!heroEl;
    const TOP_EPS = 4; // px tolerance for "all the way at the top"

    let lastY = window.scrollY;
    let stickyOffset = 0;   // scrollY at which sticky activates
    let reservedHeight = 0; // height reserved in page flow when fixed
    let ticking = false;

    function measure() {
      // Reserve the header's own natural height when it goes fixed,
      // so the page below doesn't collapse upward by that amount.
      reservedHeight = section ? section.offsetHeight : body.offsetHeight;
      // Activate sticky exactly when the header reaches the top of the viewport.
      // When an announcement bar (or any section) sits above the header, its
      // height equals section.offsetTop — so sticky takes over right as that
      // scrolls past, with no visible position jump. When the header is the
      // first thing on the page (offsetTop = 0) we fall back to the old
      // "scroll past the header" trigger so the header doesn't snap fixed on
      // the very first pixel of scroll.
      const topOffset = section ? section.offsetTop : 0;
      stickyOffset = topOffset > 0 ? topOffset : reservedHeight;
    }

    function updateLogo(y) {
      let showLogo;
      if (heroMode) {
        // Show the logo while the hero is still on screen behind/under the
        // header — i.e. until the hero's bottom scrolls up past the header.
        const heroBottom = heroEl.getBoundingClientRect().bottom;
        showLogo = heroBottom > reservedHeight;
      } else {
        // Non-hero pages: logo only at the very top.
        showLogo = y <= TOP_EPS;
      }
      header.classList.toggle('xo-header--logo-hidden', !showLogo);
    }

    function tick() {
      const y = window.scrollY;

      if (y <= stickyOffset) {
        header.classList.remove('xo-header--js-sticky', 'xo-header--js-hidden');
        if (section) section.style.minHeight = '';
      } else {
        if (!header.classList.contains('xo-header--js-sticky')) {
          if (section) section.style.minHeight = reservedHeight + 'px';
          header.classList.add('xo-header--js-sticky');
        }
        if (y > lastY) {
          header.classList.add('xo-header--js-hidden');
        } else {
          header.classList.remove('xo-header--js-hidden');
        }
      }

      updateLogo(y);

      lastY = y;
      ticking = false;
    }

    measure();
    updateLogo(window.scrollY);
    window.addEventListener('load', function () { measure(); updateLogo(window.scrollY); }, { passive: true });
    window.addEventListener('resize', function () { measure(); updateLogo(window.scrollY); }, { passive: true });

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(tick);
        ticking = true;
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
